export default __webpack_public_path__ + "static/media/metrics-icon.c105706b.svg";